import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenServiceService } from './token-service.service';
import { GENERAL_CONSTANTS } from '../core/constants/General-constants';

declare global {
  interface Window {
    kountSDK: any;
  }
}

@Injectable({ providedIn: 'root' })
export class KountService {
  constructor(public http: HttpClient, public tokenService: TokenServiceService) { }


  async initKount({ collectEndCallback, collectBeginCallback }) {
    if (window.kountSDK !== undefined) {
      const kountConfig = {
        clientID: environment.kountClientID,
        hostname: environment.kountHostname,
        isSinglePageApp: true,
        environment: environment.kountEnvironment,
        isDebugEnabled: environment.kountIsDebugEnabled,
        callbacks: {
          'collect-end': collectEndCallback,
          'collect-begin': collectBeginCallback,
        }
      }

      return await window.kountSDK(kountConfig, crypto.randomUUID().replace(/-/g, ''));
    }

    return null;
  }

  async doCollect(): Promise<{ KountClientID: string, SessionID: string }> {
    return new Promise((resolve, reject) => {
      const collectEndCallback = (response: { KountClientID: string, SessionID: string }) => resolve(response);

      const collectBeginCallback = (response: any) => { };

      this.initKount({ collectEndCallback, collectBeginCallback }).then((response) => {
        if (response === null) reject('Kount SDK not found or failed to initialize');
      });
    });
  }

  async shouldValidateKount({ franchise }) {
    try {
      let response = await this.http.post(`${environment.urlglobal_api}/antiFraud/antiFraudValidationsConsulter`, {
        franchise,
        token: this.tokenService.getToken(),
      }).toPromise();

      if (response['CODE'] === GENERAL_CONSTANTS.OK_RESPONSE_CODE && response['DATA'].includes('KOUNT')) return true;

      throw new Error('Kount error or not active');
    } catch (error) {
      return false;
    }

  }
}
